//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["trademarkTypes", "crrKey"],
  mounted() {
    // console.log(this.trademarkTypes);
  },
  methods: {
    rAdnSI(name, type) {
      this.$emit("rAdnSI", name, type);
    },
    selectAllClass() {
      this.$emit("selectAllClass");
    },
    clickType(k, item) {
      this.$emit("clickType", k, item);
    },
    delCrrType(k, item) {
      this.$emit("delCrrType", k, item);
    }
  }
};
